// ZoomControls.js
import React from 'react';
import {RotateCcw, Share2, ZoomIn, ZoomOut, HelpCircle } from 'lucide-react';
import {debounce} from 'lodash';
import ExportToPDF from './ExportToPDF';

export default function ZoomControls({zoom, setZoom,setInstructionsVisible}) {
    const handleZoomIn = debounce(() => setZoom((z) => Math.min(z + 0.1, 2)), 150);
    const handleZoomOut = debounce(() => setZoom((z) => Math.max(z - 0.1, 0.5)), 150);

    // פונקציית איפוס הזום
    const handleReset = () => {
        setZoom(1); // מאפס את הזום ל-100%
    };

    // פונקציית שיתוף
    const handleShare = async () => {
        try {
            // יוצר URL לשיתוף עם הפרמטרים הנוכחיים
            const currentUrl = new URL(window.location.href);
            const sharedUrl = currentUrl.toString();

            // בודק אם ה-API של שיתוף זמין בדפדפן
            if (navigator.share) {
                await navigator.share({
                    title: 'עץ משפחה',
                    text: 'הנה עץ המשפחה שלי',
                    url: sharedUrl
                });
            } else {
                // אם אין תמיכה ב-Web Share API, מעתיק ללוח
                await navigator.clipboard.writeText(sharedUrl);

                // מציג הודעת אישור
                const notification = document.createElement('div');
                notification.className = 'fixed top-4 right-4 bg-white p-4 rounded-xl shadow-md z-50 text-[#937c5d]';
                notification.innerHTML = 'הקישור הועתק ללוח';
                document.body.appendChild(notification);

                // מסיר את ההודעה אחרי 3 שניות
                setTimeout(() => {
                    document.body.removeChild(notification);
                }, 3000);
            }
        } catch (error) {
            console.error('Error sharing:', error);
            alert('אירעה שגיאה בשיתוף הקישור');
        }
    };

    const buttonClass = "group flex items-center justify-center p-2 hover:bg-gradient-to-r hover:from-[#c9a66c] hover:to-[#937c5d] rounded-lg transition-all duration-300 text-[#937c5d] hover:text-white";

    return (
        <div
            className="fixed bottom-6 left-1/2 transform -translate-x-1/2 flex items-center gap-2 bg-white rounded-xl p-2 shadow-md border border-[#e6dfd4] z-[150]">
            <button
                onClick={handleZoomOut}
                className={buttonClass}
                title="הקטן"
            >
                <ZoomOut className="w-5 h-5"/>
            </button>

            <div className="px-3 py-1 bg-[#f5f1ea] rounded-lg text-sm font-medium text-[#937c5d]">
                {Math.round(zoom * 100)}%
            </div>

            <button
                onClick={handleZoomIn}
                className={buttonClass}
                title="הגדל"
            >
                <ZoomIn className="w-5 h-5"/>
            </button>

            <div className="w-px h-6 bg-[#e6dfd4] mx-1"/>

            <button
                onClick={handleReset}
                className={buttonClass}
                title="אפס זום"
            >
                <RotateCcw className="w-5 h-5"/>
            </button>

            <button
                onClick={handleShare}
                className={buttonClass}
                title="שתף"
            >
                <Share2 className="w-5 h-5"/>
            </button>
            <div className="w-px h-6 bg-[#e6dfd4] mx-1"/>
            <button
                onClick={() => window.showTreeInstructions()}
                className={buttonClass}
                title="הוראות שימוש"
            >
                <HelpCircle className="w-5 h-5"/>
            </button>
            {/*(אופציה) כפתור הורדת עץ משפחה לקובץ PDF*/}
            {/*<div className="w-px h-6 bg-[#e6dfd4] mx-1"/>*/}

            {/*<ExportToPDF/>*/}
        </div>
    );
}